<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-No-Pagebreak">INTRODUCTION</p>
<p class="ORIM-Chapter-Opener-Paragraph"><span class="small">SINCE MY EXPERIENCES IN BLACKWELL’S</span> Island Insane Asylum were published in the <em class="italic">World</em> I have received hundreds of letters in regard to it. The edition containing my story long since ran out, and I have been prevailed upon to allow it to be published in book form, to satisfy the hundreds who are yet asking for copies.</p>
<p class="ORIM-Body-Text">I am happy to be able to state as a result of my visit to the asylum and the exposures consequent thereon, that the City of New York has appropriated $1,000,000 more per annum than ever before for the care of the insane. So I have at least the satisfaction of knowing that the poor unfortunates will be the better cared for because of my work.</p>
<p class="right" style="margin-top:20px;">Nellie Bly</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled11.vue?18db2273